import React, { useRef, useEffect } from "react";
import "./Video.css"; // Import CSS file

const Video = ({ videoSrc, reverse = false }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const videoEl = videoRef.current;
    if (videoEl && videoEl.paused) {
      const tryPlay = () => {
        videoEl.play().catch((err) => {
          console.warn("Mobile autoplay blocked:", err.message);
        });
      };
      const timeout = setTimeout(tryPlay, 300);
      return () => clearTimeout(timeout);
    }
  }, []);

  return (
    <section className={`video-showcase ${reverse ? "reverse" : ""}`}>
      <div className="video-description">
        <h2>At the Heart of Scalable Manufacturing Excellence</h2>
        <p>
         Step inside Kozeé’s state-of-the-art factory — a vertically integrated facility designed for precision, consistency, and global reach. Spanning over 2 million square feet, this powerhouse of production brings together cutting-edge machinery, streamlined workflows, and skilled craftsmanship to deliver high-volume furniture solutions that meet the demands of modern retail. From raw materials to ready-to-ship products, every step reflects our commitment to quality, innovation, and operational excellence.
        </p>
      </div>
      <div className="video-container">
        <video
          ref={videoRef}
          className="showcase-video"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </section>
  );
};

export default Video;
